/* eslint-disable react/no-array-index-key */
import React from "react";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";

import checkmark from "../../images/checkmark.svg";
import AmountLineItem from "../AmountLineItem";

import "./css/chatReceipt.css";

const ChatReceipt = ({ receipt }) => (
  <div data-quid="receipt" className="receipt">
    {receipt.receiptHeader && receipt.receiptHeader.couponSavings && (
      <div className="receipt__coupon">
        <div className="receipt__coupon__title">
          <img
            className="receipt__coupon__icon"
            src={checkmark}
            alt="Coupon Applied"
            data-quid="receipt-coupon-image"
          />
          <h3 data-quid="receipt-coupon">
            Coupon Applied!{" "}
            {receipt.receiptAmounts.saved !== "$0.00" &&
              `You saved ${receipt.receiptAmounts.saved}`}
          </h3>
        </div>
        <p
          className="receipt__coupon__description"
          data-quid="receipt-coupon-description"
        >
          {receipt.receiptHeader.couponDescription}
        </p>
        <small
          className="receipt__coupon__disclaimer"
          data-quid="receipt-coupon-disclaimer"
        >
          Some crust types, toppings, and premium items may come with an
          additional charge.
        </small>
      </div>
    )}
    <div className="receipt__header">
      <p className="receipt__line__qty" data-quid="receipt-header-qty">
        Qty
      </p>
      <p className="receipt__line__details" data-quid="receipt-header-details">
        Item
      </p>
      <p className="receipt__line__price" data-quid="receipt-header-price">
        Price
      </p>
    </div>
    {receipt.lineItems.map((item, index) => (
      <div
        className="receipt__line-item"
        key={`${item.description}-${index}`}
        data-quid={`receipt-item-${index}`}
      >
        <p
          data-quid={`receipt-item-${index}-qty`}
          className="receipt__line__qty"
        >
          {item.quantity}
        </p>
        <div className="receipt__line__details">
          <p
            className="receipt__line__details__decsription"
            data-quid={`receipt-item-${index}-description`}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(item.description)
            }}
          />
          {item.toppings.map((topping, i) => (
            <p
              className="receipt__line__details__topping"
              data-quid={`receipt-item-${index}-topping-${topping}`}
              key={`${topping}-${i}`}
            >
              {topping}
            </p>
          ))}
          <small data-quid={`receipt-item-${index}-calories`}>
            {item.calories}
          </small>
        </div>
        <p data-quid="receipt-item-price" className="receipt__line__price">
          {item.price}
        </p>
      </div>
    ))}
    <div className="receipt__totals">
      <div
        className="receipt__totals__breakdown"
        data-quid="receipt-totals-breakdown"
      >
        <AmountLineItem
          title="Food &amp; Beverage"
          amount={receipt.receiptAmounts.foodAndBeverage}
        />

        {receipt.receiptAmounts.deliveryFee && (
          <AmountLineItem
            title="Delivery Charge"
            amount={receipt.receiptAmounts.deliveryFee}
          />
        )}

        <AmountLineItem title="Taxes" amount={receipt.receiptAmounts.taxes} />
      </div>
      <div
        className="receipt__totals__breakdown receipt__totals__breakdown--order-total"
        data-quid="receipt-totals-breakdown-order-total"
      >
        <AmountLineItem
          title="Order Total"
          amount={receipt.receiptAmounts.total}
        />

        {receipt.receiptAmounts.saved !== "$0.00" && (
          <AmountLineItem
            title="You Saved"
            amount={receipt.receiptAmounts.saved}
            customClass="amount__line__item--you-saved"
          />
        )}
      </div>
    </div>
  </div>
);

ChatReceipt.propTypes = {
  receipt: PropTypes.shape({
    receiptHeader: PropTypes.shape({
      couponSavings: PropTypes.string,
      couponDescription: PropTypes.string
    }),
    lineItems: PropTypes.arrayOf(
      PropTypes.shape({
        calories: PropTypes.string,
        price: PropTypes.string,
        quantity: PropTypes.string,
        description: PropTypes.string
      })
    ),
    receiptAmounts: PropTypes.shape({
      foodAndBeverage: PropTypes.string,
      taxes: PropTypes.string,
      total: PropTypes.string,
      saved: PropTypes.string
    }),
    type: PropTypes.string
  }).isRequired
};

export default ChatReceipt;
